import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function AppShell({ allowedRoles }) {
  const { user, loading, unreadCount } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg-base)' }}>
      <div>
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.5rem', color: 'var(--text-primary)', fontWeight: 800, marginBottom: 4 }}>
            Dershane Pro
          </div>
          <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>Yükleniyor...</div>
        </div>
        <div style={{ width: 280, height: 2, background: 'var(--bg-elevated)', borderRadius: 99, overflow: 'hidden' }}>
          <div style={{
            height: '100%', width: '40%',
            background: 'linear-gradient(90deg, transparent, var(--accent), transparent)',
            borderRadius: 99,
            animation: 'shimmer 1.5s infinite',
            backgroundSize: '300% 100%',
          }} />
        </div>
      </div>
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(user.rol)) {
    const roleMap = { kurucu: '/admin/dashboard', ogrenci_isleri: '/admin/dashboard', ogretmen: '/ogretmen/dashboard', rehber_ogretmen: '/rehber/dashboard', muhasebe: '/muhasebe/dashboard', veli: '/veli/dashboard', ogrenci: '/ogrenci/dashboard' };
    return <Navigate to={roleMap[user.rol] || '/login'} replace />;
  }

  return (
    <div className="app-shell">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(v => !v)} unreadCount={unreadCount} />
      <div className={`main-content ${collapsed ? 'collapsed' : ''}`}>
        <Topbar collapsed={collapsed} onToggle={() => setCollapsed(v => !v)} />
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
